import React from "react";
import {styled} from '@mui/material/styles';
import {Link} from "gatsby"

import "./richtext.css";

import WmaList from "./list";
import BaseEntityPage from "../base";

const HeadlineDiv = styled('div')(({theme}) => ({
    padding: "25px 10px",
    fontSize: "30px",
    lineHeight: "1",
    textTransform: "none",
    fontWeight: "bold",
    background: "#000",
    color: "#FFF!important",
    fontFamily: "frequenz"
}));

const BildbuttonLink = styled(Link)(() => ({
    display: 'block',
    position: 'absolute',
    fontFamily: 'opensans, Verdana, Helvetica, Arial, sans-serif',
    fontStretch: 'normal',
    fontSize: 'var(--font-size-large)',
    bottom: '12px',
    left: '10px',
    whiteSpace: 'nowrap',
    padding: '8px 15px',
    background: 'hsla(0, 0%, 0%, 0.27)',
    color: '#ffffff !important',
    border: '1px solid #FFF',
    letterSpacing: '0.06em',
    textDecoration: 'none!important',
}));

const WmaListEntityPage = (props) => {
    const {rootClassNames} = props;
    return <BaseEntityPage {...props} rootClassNames={`wma wma-list ${rootClassNames}`} listComponent={WmaList} bildButtonLinkComponent={BildbuttonLink} headlineDiv={HeadlineDiv} />;
};

export default WmaListEntityPage;
